export default {
	clone(obj) {
		return JSON.parse(JSON.stringify(obj));
	}
};